module.exports = __webpack_public_path__ + "img/about_logo_15.16b7655d.png";